import { render, staticRenderFns } from "./PopupEdit.vue?vue&type=template&id=1c0a57c7"
import script from "./PopupEdit.vue?vue&type=script&lang=js"
export * from "./PopupEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports